import type { ComponentType, SVGProps } from 'react';
import {
  Activity,
  Battery,
  Blinds,
  DoorOpen,
  Droplets,
  Flame,
  Footprints,
  Gauge,
  House,
  Lightbulb,
  Music,
  PanelTop,
  Settings,
  Sun,
  Thermometer,
  ToggleRight,
  UserCog,
  Users,
  Wind,
  Zap,
} from 'lucide-react';

export type LucideIcon = ComponentType<SVGProps<SVGSVGElement>>;

export {
  Activity,
  Battery,
  Blinds,
  DoorOpen,
  Droplets,
  Flame,
  Footprints,
  Gauge,
  House,
  House as Home,
  Lightbulb,
  Music,
  PanelTop,
  Settings,
  Sun,
  Thermometer,
  ToggleRight,
  UserCog,
  Users,
  Wind,
  Zap,
};

const SENSOR_ICONS: Record<string, LucideIcon> = {
  temperature: Thermometer,
  humidity: Droplets,
  pressure: Gauge,
  power: Zap,
  energy: Battery,
  voltage: Zap,
  current: Zap,
  illuminance: Sun,
  wind_speed: Wind,
};

const BINARY_SENSOR_ICONS: Record<string, LucideIcon> = {
  motion: Activity,
  occupancy: Users,
  presence: Users,
  door: DoorOpen,
  garage_door: DoorOpen,
  window: PanelTop,
  moisture: Droplets,
  smoke: Flame,
  battery: Battery,
};

export function sensorIconFor(domain: string, deviceClass: string | undefined): LucideIcon {
  const dc = deviceClass ?? '';
  if (domain === 'binary_sensor') return BINARY_SENSOR_ICONS[dc] ?? Activity;
  return SENSOR_ICONS[dc] ?? Gauge;
}

const DOMAIN_ICONS: Record<string, LucideIcon> = {
  light: Lightbulb,
  switch: ToggleRight,
  sensor: Gauge,
  binary_sensor: Activity,
  cover: Blinds,
  climate: Thermometer,
  media_player: Music,
  camera: Activity,
};

export function domainIcon(domain: string): LucideIcon {
  return DOMAIN_ICONS[domain] ?? Gauge;
}
